import { Component, ViewChild } from '@angular/core';
import { IonicPage, NavParams, ViewController } from 'ionic-angular';
import { RouteProvider } from '../../providers/route/route';
import { TranslateService } from '@ngx-translate/core';
import { LoggerProvider } from '../../providers/logger/logger';
import { getCurrencyDisplayName } from '../../pipes/currency-pipe';

@IonicPage()
@Component({
  selector: 'page-select-picker',
  templateUrl: 'select-picker.html',
})
export class SelectPickerPage {
  @ViewChild('searchbar') searchbar;
  @ViewChild('scroll') scroll;
  @ViewChild('ionlist') ionlist;
  title: string;
  titleId: string;
  searchBarId:string;
  itemId:string;
  header: string;
  placeholder: string;
  useIcons: boolean = false;
  noResults: boolean = false;
  hasItems: boolean = false;
  itemFieldValue;
  itemFieldText;
  itemFieldSelectedText;
  itemFieldIcon;
  itemFieldIconPrefix;
  itemFieldImage;
  itemFieldDescription;
  items = [];
  visibleItems;
  searchText;
  footerButton;
  footerButtonCallback;
  nextPage;
  onSelect;
  hideSearchbar: boolean = false;
  hideHelp: boolean = false;
  hideForwardArrow: boolean = false;
  showRightClose: boolean = false;
  borderBottom: boolean = false;
  showFavoritesOnlyOnce: boolean = false;
  errorTitle = this.translate.instant('global.noResultsText')
  errorMessage = ''
  newDesign = false;
  ignoreAccentsDuringSearch: boolean = false;
  pickerId: any;
  selectedItem;
  preSelectedItem;
  showListHeader?: boolean = false;
  canShowAllItems: boolean = true;
  isFromWallet: boolean = false;
  isBase64Icon: boolean = false;
  onBackCallback
  isItemSelected: boolean = false;

  constructor(private viewCtrl: ViewController,
              private routeProvider: RouteProvider,
              private navParams: NavParams,
              private translate: TranslateService) {

    this.onBackCallback = () => {
      this.onBackClick()
    }
  }

  ngOnInit() {
    this.title = this.navParams.get('title');
    this.titleId = this.navParams.get('titleId')?this.navParams.get('titleId')+'Title':'';
    this.searchBarId = this.navParams.get('titleId')?this.navParams.get('titleId')+'SearchBar':'';
    this.itemId = this.navParams.get('titleId')?this.navParams.get('titleId')+'Item':'';
    this.header = this.navParams.get('header');
    this.pickerId = this.navParams.get('pickerId');
    this.placeholder = this.navParams.get('placeholder');
    if (this.navParams.get('errorTitle'))
      this.errorTitle = this.navParams.get('errorTitle');
    if (this.navParams.get('errorMessage'))
      this.errorMessage = this.navParams.get('errorMessage');
    if (this.navParams.get('newDesign'))
      this.newDesign = true;

    if (this.navParams.get('useIcons'))
      this.useIcons = true;

    if (this.navParams.get('ignoreAccentsDuringSearch'))
      this.ignoreAccentsDuringSearch = true;

    this.footerButton = this.navParams.get('footerButton');
    this.footerButtonCallback = this.navParams.get('footerButtonCallback');
    this.nextPage = this.navParams.get('nextPage');
    this.onSelect = this.navParams.get('onSelect');

    this.itemFieldValue = this.navParams.get('itemFieldValue');
    this.itemFieldText = this.navParams.get('itemFieldText');
    this.itemFieldSelectedText = this.navParams.get('itemFieldSelectedText');
    this.itemFieldIcon = this.navParams.get('itemFieldIcon');
    this.itemFieldIconPrefix = this.navParams.get('itemFieldIconPrefix');
    this.itemFieldImage = this.navParams.get('itemFieldImage');
    this.itemFieldDescription = this.navParams.get('itemFieldDescription');
    this.hideSearchbar = this.navParams.get('hideSearchbar');
    this.hideHelp = this.navParams.get('hideHelp');
    this.hideForwardArrow = this.navParams.get('hideForwardArrow');
    this.showRightClose = this.navParams.get('showRightClose') ? this.navParams.get('showRightClose') : false;
    this.borderBottom = this.navParams.get('borderBottom');
    this.showFavoritesOnlyOnce = this.navParams.get('showFavoritesOnlyOnce');
    this.showListHeader = this.navParams.get('showListHeader');
    this.isFromWallet = this.navParams.get('isFromWallet');
    this.isBase64Icon = this.navParams.get('isBase64Icon') || false;
    if(this.navParams.get('canShowAllItems') !== undefined && this.navParams.get('canShowAllItems') !== null){
      this.canShowAllItems = this.navParams.get('canShowAllItems');
    }
    const itemsPromise = this.navParams.get('itemsPromise');
    const favoritePromise = this.navParams.get('favoritePromise');
    const currencyPromise = this.navParams.get('currencyPromise');
    this.preSelectedItem = this.navParams.get('itemSelected')

    const items = this.navParams.get('items');
    const favorites = this.navParams.get('favorites');
    if (items)
      this.formatItems(items, favorites, currencyPromise);
    else if (itemsPromise)
      this.waitForItems(itemsPromise, favoritePromise, currencyPromise);
    else {
      this.visibleItems = []
      LoggerProvider.info(this, "SelectPicker initialized without items or itemsPromise.")
    }

    if(this.navParams.get('addTopMargin'))
    {
      var that = this;
      window.setTimeout(() => {
        if(that.ionlist){
          that.ionlist.nativeElement.style.marginTop = '16px';
        }
      }, 50);
    }

  }

  async waitForItems(itemsPromise, favoritePromise, currencyPromise) {
    let allitems = await itemsPromise;
    allitems = [].concat(allitems); // create a new array so we don't keep the reference and could accidentely modify the existing one

    let favorites: any = null;
    let currencies: any = null;

    if (favoritePromise) {
      favorites = await favoritePromise;
      favorites = [].concat(favorites); // create a new array so we don't keep the reference and could accidentely modify the existing one
    }

    if(currencyPromise) {
      currencies = await currencyPromise;
      currencies = [].concat(currencies);
    }
    if(this.canShowAllItems === false){
      this.hideSearchbar = true;
      this.showListHeader = false;
    }
    this.hasItems = true;
    this.formatItems(allitems, favorites, currencies);
  }

  formatItems(allitems, favorites, currencies) {
    if (favorites && favorites.length > 0) {
      const items = allitems;
      const values = [];
      allitems = [];
      if (currencies && currencies.length > 0) {
        if (this.showListHeader && !currencies[0].isHeader) {
          currencies.unshift({
            text: this.translate.instant('form.moneyTransferCalculatorForm.selectCurrenciesLabel'),
            isHeader: this.showListHeader
          })
        }

        for (let i = 0; i < currencies.length; i++) {
          const currency = currencies[i];
          if (currency) {
            currency.favorite = true;
            values.push(currency.value);
            allitems.push(currency);
          }
        }
      }

      if (favorites && !currencies) {
        if (this.showListHeader && favorites && favorites.length > 0 && !favorites[0].isHeader) {
          favorites.unshift({
            text: this.translate.instant('form.moneyTransferCalculatorForm.topCountriesLabel'),
            isHeader: this.showListHeader
          })
        }

        for (let i = 0; i < favorites.length; i++) {
          const favorite = favorites[i];
          if (favorite) {
            if (favorite.isHeader) {
              allitems.push(favorite);
              continue;
            }
            const item = items.find((item) => item.value === favorite.value);
            let availableCurrencies = item ? item.availableCurrencies : [];
            if (availableCurrencies && availableCurrencies.length > 0) {
              favorite.favorite = true;
              availableCurrencies = this.sortCurrencies([...availableCurrencies], favorite.value);
              allitems.push({
                ...favorite,
                text: `${favorite.text} - ${availableCurrencies.map(c => getCurrencyDisplayName(c)).join(', ')}`,
                availableCurrencies
              });

            } else {
              allitems.push(favorite);
            }
            values.push(favorite.value);
          }
        }
      }

      if (this.canShowAllItems) {
        if (this.showListHeader && items && items.length > 0 && !items[0].isHeader) {
          items.unshift({
            text: this.translate.instant('form.moneyTransferCalculatorForm.allCountriesLabel'),
            isHeader: this.showListHeader
          })
        }
        for (let i = 0; i < items.length; i++) {
          const item = items[i];
          if (item.favorite && this.showFavoritesOnlyOnce)
            continue;
          if(item.availableCurrencies && item.availableCurrencies.length > 0) {
            const sortedCurrencies = this.sortCurrencies([...item.availableCurrencies], item.value);
            sortedCurrencies.forEach((currency) => {
              if (currencies && currencies.find((c) => (c.country === item.value && c.currency === currency))) {
                // if currency is already displayed above don't display it twice
                return;
              }
              allitems.push({
                country: item.value,
                text: `${item.text} - ${getCurrencyDisplayName(currency)}`,
                value: item.value,
                currency: currency,
                favorite: false,
                availableCurrencies: item.availableCurrencies
              });
            })
          } else {
            item.favorite = false;
            allitems.push(item);
          }
        }
      }
    }
    //retrieve the preSelectedItem to updater isSelected

    for (let i = 0; i < allitems.length; i++) {
      if (allitems[i]) {
        if (allitems[i].category)
          allitems[i] = this.setIsSelectedItem('category', allitems[i]);
        else if (allitems[i].Id)
          allitems[i] = this.setIsSelectedItem('Id', allitems[i]);
        else if (allitems[i].abbreviation)
          allitems[i] = this.setIsSelectedItem('abbreviation', allitems[i]);
        else
          allitems[i] = this.setIsSelectedItem('value', allitems[i]);
      }
    }
    this.items = SelectPickerPage.formatItems(this, allitems);
    if (this.items) this.hasItems = true;
    this.onSearch();
  }


  static formatItems(params, items) {
    let newitems = items;
    if (params.itemFieldValue || params.itemFieldText || params.itemFieldIcon || params.itemFieldSelectedText || params.itemFieldImage) {
      newitems = [];
      for (let i=0; i < items.length; i++) {
        const item = { ...items[i] };
        if (params.itemFieldValue)
          item.value = item[params.itemFieldValue];
        if (params.itemFieldText)
          item.text = item[params.itemFieldText];
        if (params.itemFieldIcon && item[params.itemFieldIcon]) {
          item.icon = (params.itemFieldIconPrefix + item[params.itemFieldIcon]).toLowerCase();
          if(params.itemFieldIconPrefix.indexOf('custom-icon-country') == 0) {
            const country = item[params.itemFieldIcon];
            if (country) {
              const splitted = country.split('_');
              if (splitted && splitted.length > 0)
                item.flag = 'assets/countryFlagSvg/' + splitted[0].toUpperCase() + '.svg';
            }
          }
        }
        if (params.itemFieldSelectedText)
          item.selectedText = item[params.itemFieldSelectedText];
        if (params.itemFieldDescription)
          item.description = item[params.itemFieldDescription];
        item.img = params.itemFieldImage

        newitems.push(item);
      }
    }
    return newitems;
  }

  selectItem(item) {
    this.isItemSelected = true;
    if(item.isHeader) {
      return;
    }

    this.visibleItems.forEach ( x =>{
      x.isSelected = false;
    });


    if (this.preSelectedItem) { // in some cases there is no pre selection
      this.selectedItem = item;
      this.selectedItem.isSelected = true;
      this.preSelectedItem.isSelected = false;
    }
    else
      if (!this.preSelectedItem) {
        this.selectedItem = item;
        this.selectedItem.isSelected = true;
      }
    if (this.onSelect)
      this.onSelect(item, this.viewCtrl);
    else if (this.nextPage)
      this.routeProvider.replace(this.nextPage, { country: item });
    else
      this.viewCtrl.dismiss(item);
  }


  setIsSelectedItem(itemReference: string, item: any) {
    if (this.preSelectedItem) {
      if (item[itemReference] === this.preSelectedItem.value)
        item.isSelected = true;
      else
        item.isSelected = false;
    }
    else
      item.isSelected = false;

    return item;
  }

  checkSearchText(item) {
    if (!this.searchText)
      return true;
    let itemToSearch = "";
    let pos = false;
    if(item.Name){
      itemToSearch = item.Name.toLowerCase();
    }
    else {
      itemToSearch = item.text.toLowerCase();
    }

    let searchText = this.searchText;
    if (this.ignoreAccentsDuringSearch) {
      // removing accents of characters before comparing
      itemToSearch = itemToSearch.normalize("NFD").replace(/[\u0300-\u036f]/g, '');
      searchText = searchText.normalize("NFD").replace(/[\u0300-\u036f]/g, '');
    }

    let phoneCode = '', countryName = '';
    const items = itemToSearch.split(' ');

    if (items.length === 1) {
      countryName = items[0].toLowerCase();
    } else if (items.length > 1) {
      phoneCode = items[0];
      countryName = items[1].toLowerCase();
    }

    let itemTosearch = "";
    if (item.Name)
      itemTosearch = item.Name.toLowerCase()
    else
      itemTosearch = item.text.toLowerCase()
    if (this.ignoreAccentsDuringSearch)
      itemTosearch = itemTosearch.normalize("NFD").replace(/[\u0300-\u036f]/g, ""); //removing accents of characters before comparing

    //do search only for number so it doesn't affect other searches - wallet
    if(this.pickerId == "phonePickerRegisterationStepUser" && this.isNumeric(searchText)) {
        let tempPhoneCode = phoneCode.substring(phoneCode.lastIndexOf("+") + 1);
        if(tempPhoneCode.startsWith(searchText.toLowerCase())){
          return true;
        }
        return false;
    }

    if (itemTosearch.indexOf(searchText.toLowerCase()) > -1)
      pos = true;
    else if (item.countryCode && item.countryCode.indexOf(searchText.replace('+','')) > -1)
      pos = true;
    return pos;
  }

  private isNumeric(value) {
    return /^\d+$/.test(value);
  }


  onSearch() {
    this.searchText = this.searchbar && this.searchbar.searchdiv ? this.searchbar.searchdiv.value : '';

    let visibleItems = [];
    if (this.searchText) {
      visibleItems = [];
      for (let i = 0; i < this.items.length; i++) {
        const item = this.items[i];
        if (this.checkSearchText(item)) {
          // if item has available currencies we will have separate entries for the currencies hence ignore the favorite entry and show all entries although the have the same value (country value)
          if (item && item.availableCurrencies) {
            if (!item.favorite)
              visibleItems.push(item);
          }
          else if (item && item.value) {
            if (visibleItems.filter((visibleItem) => {
              return visibleItem.value == item.value
            }).length === 0)// Filter favorite duplicates in search
              visibleItems.push(item);
          }
          else if (item && item.Name) {
            if (visibleItems.filter((visibleItem) => {
              return visibleItem.value == item.Name
            }).length === 0)// Filter favorite duplicates in search
              visibleItems.push(item);
          }
        }

      }
    }
    else if (this.items && this.items.length > 0)
      visibleItems = visibleItems.concat(this.items);
    
    this.visibleItems = [];

    // wait until we have received the items to show no result otherwise it could happen that since we're still loading the items we would get here no visibleItems
    // but then we shouldn't show no result but still keep the content loader until the items are loaded
    if (this.hasItems && visibleItems && visibleItems.length === 0)
      this.noResults = true;
    else {
      this.noResults = false;
      this.processVisibleItems(visibleItems, this.searchText);
    }

    window.requestAnimationFrame(() => {
      if(this.scroll) this.scroll.update(true);
    });
  }

  processVisibleItems(visibleItems, searchText) {
    if (visibleItems.length === 0 || searchText !== this.searchText)
      return;

    for (let i=0; i < 10; i++) {
      const item = visibleItems.shift();
      if (item)
        this.visibleItems.push(item);
      if (visibleItems.length === 0)
        return;
    }

    window.setTimeout(() => {
      this.processVisibleItems(visibleItems, searchText);
    }, 50);
  }

  onSearchCancel() {
    this.searchText = '';
    this.visibleItems = this.items;
  }

  clickFooterButton() {
    if (this.footerButtonCallback)
      this.footerButtonCallback(this.viewCtrl);
    else
      this.viewCtrl.dismiss(null);
  }

  getItemId(extra){
    if(extra)
      return this.itemId+extra
    return this.itemId?this.itemId:'';
  }

  calculateHeight(item){
    if (item.isHeader)
      return '44px'; // 32px + 24px padding top
    else if (item.img)
      return '88px';
    else if (this.isBase64Icon)
      return '80px';
    else
      return '56px';
  }

  getLargeTitle(){
    if(this.isFromWallet && this.isFromWallet!==undefined)
      return this.header
    else
      return '';
  }

  getHeaderTitle(){
    let title;
    if(this.isFromWallet && this.isFromWallet!==undefined)
      title = '';
    else if(this.title)
      title = this.title;
    else
    title = this.header;

    return title;
  }

  onBackClick() {
    this.viewCtrl.dismiss({"searchText": this.searchText,"itemSelected": this.isItemSelected});
  }

  // Only apply special sorting for Haiti (HT)
  private sortCurrencies(currencies: string[], countryCode?: string): string[] {
    if (!currencies || currencies.length === 0) {
      return currencies;
    }
    if (countryCode === 'HT') {
      return currencies.sort((a, b) => {
        if (a === 'USD') return -1;
        if (b === 'USD') return 1;
        return 0;
      });
    }
    return currencies;
  }


}



// WEBPACK FOOTER //
// ./src/pages/select-picker/select-picker.ts